import React, { useEffect } from 'react'
import ColorsList from '../Components/ColorsList';
import Header from '../Components/Header'
import Mail from '../Components/Mail';
import Sidebar from '../Components/Sidebar';
import Social from '../Components/Social';
import { useTheme } from '../Context/ThemeContext'
import social from "../Data/social.json";

function Index({ children }) {

    const { theme, backgroundColor } = useTheme();

    useEffect(() => {
    }, [theme]);

    return (
        <div className={`${backgroundColor} min-h-screen flex flex-col px-3 md:px-10 dark:${backgroundColor} transition-all duration-500`}>
            <div className='hidden md:block'>
                {<ColorsList />}
            </div>
            <Header />
            <div className='grid grid-cols-1 md:grid-cols-7 gap-4 flex-grow'>
                <div className='hidden md:col-span-1 md:flex flex-col items-center justify-end'>
                    {social && social.map((item, index) => (
                        <Social key={index} link={item.link} icon={item.icon} />
                    ))}
                </div>
                <div className='md:col-span-5'>
                    {children}
                </div>
                <div className='hidden md:col-span-1 md:flex flex-col items-center justify-end'>
                    <Mail mail={process.env.REACT_APP_MAIL_TO_ADDRESS} />
                </div>
            </div>
            <Sidebar />
        </div>
    )
}

export default Index